import { useMutation, useQueryClient } from '@tanstack/react-query'
import { IPermit } from '@core/entities/permit/Permit'
import {
  permitKeys,
  RequestTypes,
} from '@core/react-query/features/permits/permit'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useRequestResumePermit = () => {
  const queryClient = useQueryClient()
  return useMutation<
    IPermit,
    RequestErrorType,
    RequestTypes['requestResumePermit']
  >({
    ...permitKeys.requestResumePermit,
    onSuccess: (permit, ...args) => {
      queryClient.setQueryData(
        permitKeys.byId({ permitId: permit.id }).queryKey,
        permit,
      )
    },
  })
}
